function shopifyGraphQlIdToSourceId(objectType: string, sourceId: string) {
	const expectedPrefix = `gid://shopify/${objectType}/`;
	if (!sourceId.startsWith(expectedPrefix)) {
		throw new Error(`Expected ${expectedPrefix} but got ${sourceId}`);
	}
	return sourceId.replace(expectedPrefix, "");
}

export { shopifyGraphQlIdToSourceId };
